import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./Schema.vue.script.js";
/* empty css                     */
//#region src/schema/Schema.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-8f822427"]]);
//#endregion
export { n as default };

//# sourceMappingURL=Schema.vue.js.map